import PropTypes from 'prop-types';
import React, { memo } from 'react';
import NextImage from '../NextImage';
import { extractHighAndLowResImages } from '../helpers';
import styles from './styles.module.scss';
import {
  LARGE,
  MEDIUM,
  HERO,
  SMALL,
  TILESMALL,
  XLARGE,
  XSMALL
} from '@/config/assets';
import { classes } from '@/helpers/styling';

const DEFAULT_OBJECT = {};

const HeroImage = React.forwardRef(({
  assetsObj,
  assetSize,
  className,
  imageClassName,
  loading,
  forceHighDensity,
  onClick,
  isInitialRender,
  ...props
}, ref) => {
  const { srcLowRes, srcHighRes } = extractHighAndLowResImages({
    assetSizeKey: assetSize,
    assetsObj,
    imageType: HERO,
    forceAssetSizeKey: assetSize,
    forceHighDensity,
    isInitialRender
  });

  return (
    <NextImage
      className={ classes(
        styles.heroImageComponent,
        className
      ) }
      imageClassName={ imageClassName }
      loading={ loading }
      onClick={ onClick }
      ref={ ref }
      srcHighRes={ srcHighRes }
      srcLowRes={ srcLowRes }
      { ...props }
    />
  );
});

HeroImage.propTypes = {
  assetsObj: PropTypes.object,
  assetSize: PropTypes.oneOf([XLARGE, LARGE, MEDIUM, SMALL, XSMALL, TILESMALL]),
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  forceHighDensity: PropTypes.bool,
  isInitialRender: PropTypes.bool
};

HeroImage.defaultProps = {
  assetsObj: DEFAULT_OBJECT,
  assetSize: undefined,
  loading: false,
  onClick: undefined,
  className: '',
  imageClassName: '',
  forceHighDensity: false,
  isInitialRender: false
};

export default memo(HeroImage);